import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  ref: "selectDisplay",
  class: "custom-select__input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemList = _resolveComponent("ItemList")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "customSelect",
    class: _normalizeClass([
            'custom-select',
            _ctx.isExpanded ? 'expanded' : '',
            _ctx.isReverse ? 'reversed' : '',
            _ctx.isValid ? 'valid' : '',
            _ctx.hasError ? 'has-error' : '',
        ]),
    style: _normalizeStyle({
            top: _ctx.isExpanded
                ? _ctx.isReverse
                    ? 'unset'
                    : '-' + _ctx.listHeight + 'px'
                : '0',
            bottom: _ctx.isExpanded && _ctx.isReverse ? '-' + _ctx.listHeight + 'px' : 'unset',
            border: _ctx.isExpanded ? '1px solid #192241' : '',
            boxShadow: _ctx.isExpanded ? '0 3px 6px 0 rgba(0, 0, 0, 0.16)' : '',
        }),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args))),
    onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFocusOut && _ctx.handleFocusOut(...args)))
  }, [
    _createElementVNode("select", {
      ref: "select",
      class: "visually-hidden",
      onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
    }, null, 544),
    _createElementVNode("span", {
      class: _normalizeClass(["custom-select__label", [_ctx.selectedDisplayValue !== _ctx.placeholder ? 'not-empty' : '']]),
      style: _normalizeStyle({ opacity: _ctx.isExpanded ? 1 : 0 })
    }, _toDisplayString(_ctx.label), 7),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["custom-select__input-value", [
                    _ctx.selectedDisplayValue !== _ctx.placeholder ? 'isSelected' : '',
                ]])
      }, [
        (_ctx.flags && _ctx.id)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(`country-flag fi fi-${_ctx.id.toLowerCase()}`)
            }, null, 2))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.truncatedValue), 1)
      ], 2),
      _createElementVNode("span", {
        class: "custom-select__input-arrow",
        style: _normalizeStyle({ transform: _ctx.isExpanded ? 'rotate(-135deg)' : '' })
      }, null, 4)
    ], 512),
    _createVNode(_component_ItemList, {
      ref: "itemListRef",
      class: "custom-select__item-list fs-11",
      "is-default-open": _ctx.isOpen,
      "item-list": _ctx.itemList,
      "show-flags": _ctx.flags,
      onSelectOption: _ctx.selectOption
    }, null, 8, ["is-default-open", "item-list", "show-flags", "onSelectOption"]),
    _createVNode(_component_Error, { name: _ctx.name }, null, 8, ["name"])
  ], 38))
}